import { AsyncPipe } from '@angular/common';
import { Component, Input, TemplateRef, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent, IconButtonComponent, IconComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { WatchlistFacade, WatchlistVM } from '@zero/shared/util-global-state';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'web-components-watchlist-toggle',
  templateUrl: './watchlist-toggle.component.html',
  imports: [AsyncPipe, TranslocoPipe, NgbTooltipModule, ButtonComponent, ModalComponent, IconComponent, IconButtonComponent],
})
export class WatchlistToggleComponent {
  readonly #watchlistFacade = inject(WatchlistFacade);
  readonly #modalService = inject(NgbModal);

  @Input() public set isin(value: string) {
    this.#isin = value;
    this.watchlistItem$ = this.#watchlistFacade.getWatchlistItemByIsin$(value);
    this.note$ = this.watchlistItem$.pipe(map((item) => item?.note));
  }
  @Input() public iconSize?: 'small' | 'default';
  @Input() public type?: 'default' | 'instrument-details-header' = 'default';

  public modalmsg: string;
  public isErrorModal = false;

  public watchlistItem$: Observable<WatchlistVM>;
  public note$: Observable<string | undefined>;

  #isin: string;

  public toggleWatchlist(modalContent: TemplateRef<HTMLElement>, ev: MouseEvent, item: WatchlistVM): void {
    if (item) {
      if (item.note && item.note !== '') {
        ev.stopPropagation();
        this.isErrorModal = false;
        this.modalmsg = `Wenn Du den Wert entfernst, wird die Notiz "${item.note}" auch gelöscht.`;
        this.#modalService.open(modalContent, { size: 'md' }).result.then(
          () => this.#removeFromWatchlist(),
          () => {
            // do nothing
          },
        );
      } else {
        this.#removeFromWatchlist();
      }
    } else {
      this.#watchlistFacade.addWatchlistItem(this.#isin);
    }
  }

  #removeFromWatchlist() {
    this.#watchlistFacade.removeWatchlistItem(this.#isin);
  }
}
